import * as React from 'react'
import clsx from 'clsx'
import { Typography, TypographyProps } from '../Typography'
import styles from './index.module.scss'

export interface AlertTitleClasses {
  /** Styles applied to the root element. */
  root: string
}

export interface AlertTitleProps extends TypographyProps {
  /**
   * Override or extend the styles applied to the component.
   */
  classes?: Partial<AlertTitleClasses>
}

export const AlertTitle = React.forwardRef<HTMLDivElement, AlertTitleProps>(
  function AlertTitle(props, ref) {
    const { className, classes, children, ...other } = props

    return (
      <Typography
        component="span"
        ref={ref}
        className={clsx(styles.root, classes?.root, className)}
        weight="demi"
        {...other}
      >
        {children}
      </Typography>
    )
  }
)
